import { render, staticRenderFns } from "./BatchMassSend.vue?vue&type=template&id=4bdf6b96&scoped=true"
import script from "./BatchMassSend.vue?vue&type=script&lang=js"
export * from "./BatchMassSend.vue?vue&type=script&lang=js"
import style0 from "./BatchMassSend.vue?vue&type=style&index=0&id=4bdf6b96&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdf6b96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bdf6b96')) {
      api.createRecord('4bdf6b96', component.options)
    } else {
      api.reload('4bdf6b96', component.options)
    }
    module.hot.accept("./BatchMassSend.vue?vue&type=template&id=4bdf6b96&scoped=true", function () {
      api.rerender('4bdf6b96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/medicaid/claims/components/BatchMassSend.vue"
export default component.exports